// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"a34831d1","239":"713a2f5f","453":"500f59a7","455":"a144d178","977":"0515714c"}[chunkId] + ".chunk.js";
};